module.exports = __webpack_public_path__ + "static/media/142-tibet.2f02d332.svg";